"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldBadgeType = exports.BadgeType = void 0;
var BadgeType;
(function (BadgeType) {
    BadgeType["default"] = "default";
    BadgeType["white"] = "white";
    BadgeType["neutral"] = "neutral";
    BadgeType["success"] = "success";
    BadgeType["warning"] = "warning";
    BadgeType["alert"] = "alert";
    BadgeType["info"] = "info";
    BadgeType["dark"] = "dark";
    BadgeType["red"] = "red";
    BadgeType["infoBlue"] = "infoBlue";
})(BadgeType || (exports.BadgeType = BadgeType = {}));
var OldBadgeType;
(function (OldBadgeType) {
    OldBadgeType["default"] = "old-default";
    OldBadgeType["white"] = "old-white";
    OldBadgeType["neutral"] = "old-neutral";
    OldBadgeType["success"] = "old-success";
    OldBadgeType["warning"] = "old-warning";
    OldBadgeType["alert"] = "old-alert";
    OldBadgeType["info"] = "old-info";
    OldBadgeType["dark"] = "old-dark";
    OldBadgeType["red"] = "old-red";
    OldBadgeType["infoBlue"] = "old-infoBlue";
})(OldBadgeType || (exports.OldBadgeType = OldBadgeType = {}));
//# sourceMappingURL=components.js.map